import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import * as AvatarPrimitive from "@radix-ui/react-avatar";
const Avatar = React.forwardRef(({ ...props }, ref) => (_jsx(AvatarPrimitive.Root, { ref: ref, ...props, "aria-label": "User avatar" })));
Avatar.displayName = AvatarPrimitive.Root.displayName;
const AvatarImage = React.forwardRef(({ ...props }, ref) => (_jsx(AvatarPrimitive.Image, { ref: ref, ...props, alt: "User avatar", "aria-label": "User avatar" })));
AvatarImage.displayName = AvatarPrimitive.Image.displayName;
export { Avatar, AvatarImage };
//# sourceMappingURL=Avatar.js.map